export default Object.freeze({
  AWS: 1,
  GCP: 2,
  AZURE: 3,
});
